// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.prefix-label[data-v-534b49f0] {\n\tmargin: 0 13px;\n}\n.label[data-v-534b49f0] {\n\tfont-size: 9pt;\n\tcolor: var(--main-blue-4);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
